module.exports = __webpack_public_path__ + "img/tdt.b9333a26.jpg";